import { Injectable, Inject, EventEmitter } from "@angular/core";
import { Subject } from "rxjs/Subject";
import { BehaviorSubject } from "rxjs";
import { Observable } from "rxjs/Rx";
import { Http, Response } from "@angular/http";
import { map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";

@Injectable()
export class PushNotificationService {
  constructor(private http: HttpClient) {}
  registerFireBaseToken(data): Observable<any> {
    const url = environment.notification_url + "notification/token/subscribe";    
    return this.http.post(url,data).pipe(map((response: number) => {
      return response;
    }));
  }
}
